import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private zone: NgZone,
  ) {}

  handleError(error: any): void {
    const toastr = this.injector.get(ToastrService);

    let message = 'Something went wrong';

    if (error instanceof HttpErrorResponse) {
      // API errors
      if (!navigator.onLine) {
        message = 'No Internet connection';
      } else {
        message = error?.error?.message || error?.error?.error?.message || 'Server error';
      }
    } else if (error instanceof Error) {
      // JS/runtime errors
      if (!navigator.onLine) {
        message = 'No Internet connection';
      } else if (error.message.includes('Failed to fetch dynamically imported module')) {
        message = 'No Internet connection';
      } else {
        message = error.message;
      }
    }

    this.zone.run(() => {
      toastr.error(message, 'Error');
    });

    console.error('Global Error:', error);
  }
}
